import React, { useCallback, useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import moment from "moment";
import DatePicker from "../../components/FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import useDebounce from "../../hooks/useDebounce";
import SelectInput from "../FormFields/SelectInput";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import CustomButton from "../CustomButton";
import { downloadReports, getArrayOfSelectedStoresCode } from "../../utils/helpers";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";
import RejectModal from "../../CustomRejectModal/RejectModal";

const PendingRequest = () => {
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: apiCall1 } = useApi();
  const [isRejectVisible, setIsRejectVisible] = useState({
    isOpen: false,
    data: [],
  });
  const {
    selectedStores = {},
    storeDropdownState = [],
    setSelectedStores,
    user: { userLabel = "" },
  } = useAuth();

  const {storeCode = ""} = selectedStores?.storeDetails || selectedStores?.[0] || {}
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 500);
  const [checkboxPropData, setCheckboxPropData] = useState([]);

  const isStoreActive = userLabel == "Store";

  useEffect(() => {
    // if (isStoreActive) {
      pendingRequestTableDataHandler(
        startDate,
        endDate,
        selectedStores?.storeDetails?.storeCode || ""
      );
    // } else {
    //   if (storeCode.length > 0 && storeCode.length !== 0) {
    //     pendingRequestTableDataHandler(
    //       startDate,
    //       endDate,
    //       selectedStores?.storeDetails?.storeCode || ""
    //     );
    //   }
    // }
  }, [selectedStores]);

  const pendingRequestTableDataHandler = (start, end, storeC) => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: start,
          endDate: end,
        }).toString(),
      },
      { replace: true }
    );
    // if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: debouncedSearchText,
          status: "PENDING",
          storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
          // storeC
          //   ? storeC !== "All" ? [storeC] : null
          //   : userLabel == "Store" ? null : [storeCode],
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
    // }
  };
  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null)
      pendingRequestTableDataHandler(
        start,
        end,
        selectedStores?.storeDetails?.storeCode || ""
      );
  };

  const pendingRequestsColumns = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: (rowData) => {
          return <div>{rowData?.date}</div>;
        },
      },
      {
        Header: "Request For",
        accessor: "request_for",
        Cell: (rowData) => {
          const value = rowData.row.original;
          if (!value) {
            return "-";
          }
          return (
            <div className="py-4">
              <div className="font-size-small">{value?.head}</div>
              {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
                {value?.sub_head}
              </div> */}
            </div>
          );
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: (rowData) => {
          const value = rowData?.row.original.description;
          return value || "-";
        },
      },
      {
        Header: "Quantity",
        accessor: "qty",
        Cell: (rowData) => {
          const value = rowData?.row.original.quantity;
          return value || "-";
        },
      },
      {
        Header: "Rate (₹)",
        accessor: "rate",
        Cell: (rowData) => {
          const value = rowData?.row?.original?.rate;
          let amount;
          if(typeof value == "string"){
            amount = Number(value).toFixed(2);
          } else {
            amount = value
          }
          return amount || "-";
        },
      },
      {
        Header: "Total Amountt (₹)",
        accessor: "amount",
        Cell: (rowData) => {
          const value = rowData?.row?.original?.amount;
          let amount;
          if(typeof value == "string"){
            amount = Number(value).toFixed(2);
          } else {
            amount = value
          }
          return amount || "-";
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        Cell: (props) => {
          const id = props?.row?.original?.parentId;
          const ids = [
            { id: id, approvedAmount: props?.row?.original?.amount },
          ];
          return (
            <div className="flex items-center justify-end gap-x-3 pr-6">
              <img
                src={icons.squareTickIcon}
                alt="accept icon"
                className="cursor-pointer"
                onClick={() => approveRequestHandler(ids)}
              />
              <img
                src={icons.squareTimesIcon}
                alt="reject icon"
                className="cursor-pointer"
                // onClick={() => rejectRequestHandler([id])}
                onClick={() => setIsRejectVisible({ data: [id], isOpen: true })}
              />
            </div>
          );
        },
      },
    ],
    []
  );

  const ImprestRequestApi = (payload, status) => {
    apiCall1({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        pendingRequestTableDataHandler(
          startDate,
          endDate,
          selectedStores?.storeDetails?.storeCode || ""
        );
        setIsRejectVisible({ ...isRejectVisible, isOpen: false });
        toast.success(status);
      },
    });
  };

  const approveRequestHandler = (id = []) => {
    let payload = {
      approved: id,
      comment: "",
      rejected: [],
    };
    ImprestRequestApi(payload, "Approved Request Successfully");
  };

  const rejectRequestHandler = (id = []) => {
    let payload = {
      approved: [],
      comment: "",
      rejected: id,
    };
    ImprestRequestApi(payload, "Rejected Request Successfully");
  };

  let reportData = [
    {
      sheet: "Reports",
      columns: [
        { label: "Date", value: (row) => row.date }, // Top level data
        { label: "Request For", value: (row) => row.head }, // Top level data
        // { label: "Sub Head", value: (row) => row.sub_head }, // Top level data
        { label: "Description", value: (row) => row.description }, // Top level data
        { label: "Rate", value: (row) => row.rate }, // Top level data
        { label: "Quantity", value: (row) => row.quantity }, // Top level data
        { label: "Total Amount", value: (row) => row.amount }, // Top level data
        { label: "Approval Status", value: (row) => row.approval_status }, // Top level data
      ],
      content: checkboxPropData.map((i) => i.original),
    },
  ];

  let reportSettings = {
    fileName: "pendingRequestReport", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const downloadRequestReports = () => {
    downloadReports(reportData, reportSettings);
  };

  const setCheckData = (val) => {
    setCheckboxPropData(val);
  };

  return (
    <div className="flex flex-col gap-y-5">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-x-8">
          {/* {storeDropdownState?.length ? (
            <SelectInput
              options={[
                { name: "All", storeCode: "" },
                ...storeDropdownState?.map((item) => ({
                  name: `${item?.name} (${item?.storeCode})`,
                  storeCode: item?.storeCode,
                })),
              ]}
              onChange={(val) => {
                pendingRequestTableDataHandler(
                  startDate,
                  endDate,
                  val[0]?.storeCode || ""
                );
                setSelectedStores({ storeDetails: val?.[0] || {} });
              }}
              labelField="name"
              valueField="storeCode"
              selectClassName="!max-w-[18rem] !h-[4rem] !mt-0"
              onChangeFullRes={true}
              value={
                selectedStores?.storeDetails?.storeCode
                  ? selectedStores?.storeDetails?.storeCode
                  : null
              }
            />
          ) : null} */}
          {/* 
          <InputWithIcon
            placeholder="Search"
            containerClassName="search-input-wrapper !mt-0"
            wrapperClassName="!h-[4rem]"
            inputClassName="font-size-small"
            rightIcon={icons.searchIcon}
            onChange={(e) => setSearchText(e)}
            value={searchText}
          /> */}
        </div>
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>
          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            // maxDate={new Date()}
            dateRange
          />
        </div>
      </div>
      <CustomTable
        data={data}
        columns={pendingRequestsColumns}
        showCheckboxes={true}
        onCheckboxSelect={(value) => {
          // setCheckData(value);
          if (data?.length) {
            setCheckData(value);
          }
        }}
        // isGlobalSearchEnable={true}
      />
      <div
        className={`mt-4 flex items-center justify-end gap-x-5 ${
          ((checkboxPropData.length > 0) && (data.length > 0)) ? "" : "disabled-kv"
        }`}
      >
        <CustomButton
          onClick={downloadRequestReports}
          title="Download"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />
        <CustomButton
          title="Reject"
          onClick={() => {
            let rejectIds =
              checkboxPropData.map((i) => i.original.parentId) || [];
            // rejectRequestHandler(rejectIds);
            setIsRejectVisible({ data: rejectIds, isOpen: true });
          }}
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />
        <CustomButton
          title="Approve"
          onClick={() => {
            let approvedIds =
              checkboxPropData.map((i) =>  ({id: i.original.parentId, approvedAmount: i.original.amount})) || [];
            approveRequestHandler(approvedIds);
          }}
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />
      </div>
      {isRejectVisible.isOpen && (
        <RejectModal
          isModalVisible={isRejectVisible}
          setIsModalVisible={setIsRejectVisible}
          rejectHandler={({ data = [], comment = "" }) => {
            const validIds = [...new Set([...data])];
            rejectRequestHandler(validIds, comment);
          }}
          title="Request"
        />
      )}
    </div>
  );
};

export default PendingRequest;
